import React from 'react';
import { Upload, Search, Wallet, CreditCard, FileText, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const SettingsAppearance = ({ settings, setSettings, handleSave, logoInputRef, handleLogoUpload, uploadingLogo }) => (
  <Card className="p-6">
    <h3 className="text-lg font-semibold text-slate-900 mb-4" style={{fontFamily: 'Manrope'}}>
      Personalización Visual
    </h3>
    <div className="space-y-6">
      <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
        <Label className="text-base font-medium">Logo de la Empresa</Label>
        <p className="text-sm text-slate-500 mb-4">Sube un archivo JPG/PNG o ingresa una URL</p>
        <div className="flex gap-4 items-start">
          <div className="w-24 h-24 rounded-lg border-2 border-dashed border-slate-300 flex items-center justify-center bg-white overflow-hidden">
            {settings.logo_url ? (
              <img src={settings.logo_url} alt="Logo" className="w-full h-full object-contain" />
            ) : (
              <Upload className="w-8 h-8 text-slate-400" />
            )}
          </div>
          <div className="flex-1 space-y-3">
            <div>
              <input type="file" ref={logoInputRef} onChange={handleLogoUpload} accept="image/jpeg,image/jpg,image/png,image/webp" className="hidden" />
              <Button type="button" variant="outline" onClick={() => logoInputRef.current?.click()} disabled={uploadingLogo} className="w-full">
                <Upload className="w-4 h-4 mr-2" />
                {uploadingLogo ? 'Subiendo...' : 'Subir Archivo'}
              </Button>
              <p className="text-xs text-slate-500 mt-1">JPG, PNG o WEBP. Máximo 2MB</p>
            </div>
            <div className="flex items-center gap-2"><span className="text-sm text-slate-500">o</span></div>
            <Input value={settings.logo_url || ''} onChange={(e) => setSettings({...settings, logo_url: e.target.value})} placeholder="https://ejemplo.com/logo.png" data-testid="logo-url-input" />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div>
          <Label>Color Primario</Label>
          <div className="flex gap-2 mt-1">
            <Input type="color" value={settings.primary_color} onChange={(e) => setSettings({...settings, primary_color: e.target.value})} className="w-20 h-10" />
            <Input value={settings.primary_color} onChange={(e) => setSettings({...settings, primary_color: e.target.value})} placeholder="#0d9488" />
          </div>
          <p className="text-xs text-slate-500 mt-1">Botones y acentos</p>
        </div>
        <div>
          <Label>Color Secundario</Label>
          <div className="flex gap-2 mt-1">
            <Input type="color" value={settings.secondary_color} onChange={(e) => setSettings({...settings, secondary_color: e.target.value})} className="w-20 h-10" />
            <Input value={settings.secondary_color} onChange={(e) => setSettings({...settings, secondary_color: e.target.value})} placeholder="#0f172a" />
          </div>
          <p className="text-xs text-slate-500 mt-1">Encabezados y texto</p>
        </div>
      </div>

      <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 mt-6">
        <h4 className="font-medium text-slate-900 mb-3">Pantalla de Búsqueda</h4>
        <p className="text-sm text-slate-600 mb-4">Personaliza el título, subtítulo e ícono de la pantalla de búsqueda</p>
        <div className="space-y-4">
          <div>
            <Label>Título Principal</Label>
            <Input value={settings.search_title || ''} onChange={(e) => setSettings({...settings, search_title: e.target.value})} placeholder="Consulta tu Deuda" className="mt-1" />
          </div>
          <div>
            <Label>Subtítulo</Label>
            <Input value={settings.search_subtitle || ''} onChange={(e) => setSettings({...settings, search_subtitle: e.target.value})} placeholder="Ingresa tu DNI o Código de Cliente..." className="mt-1" />
          </div>
          <div>
            <Label>Ícono</Label>
            <div className="grid grid-cols-5 gap-2 mt-2">
              {[
                { id: 'search', icon: Search, label: 'Lupa' },
                { id: 'wallet', icon: Wallet, label: 'Billetera' },
                { id: 'creditcard', icon: CreditCard, label: 'Tarjeta' },
                { id: 'document', icon: FileText, label: 'Documento' },
                { id: 'user', icon: User, label: 'Usuario' }
              ].map(({ id, icon: Icon, label }) => (
                <button key={id} type="button" onClick={() => setSettings({...settings, search_icon: id})} className={`flex flex-col items-center justify-center p-3 rounded-lg border-2 transition-all ${settings.search_icon === id ? 'border-teal-500 bg-teal-50' : 'border-slate-200 bg-white hover:border-slate-300'}`}>
                  <Icon className={`w-6 h-6 ${settings.search_icon === id ? 'text-teal-600' : 'text-slate-600'}`} />
                  <span className={`text-xs mt-1 ${settings.search_icon === id ? 'text-teal-600 font-medium' : 'text-slate-500'}`}>{label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Button onClick={handleSave} className="w-full bg-teal-600 hover:bg-teal-700">Guardar Apariencia</Button>
    </div>
  </Card>
);
